export const setActiveListProfession = (payload) => ({
  type: 'SET_ACTIVE_LIST_PROFESSION',
  payload,
})
export const setActiveProfession = (payload) => ({
  type: 'SET_ACTIVE_PROFESSION',
  payload,
})
export const setActiveVacancy = (payload) => ({
  type: 'SET_ACTIVE_VACANCY',
  payload,
})
export const setDataProfession = (payload) => ({
  type: 'SET_DATA_PROFESSION',
  payload,
})
export const setDataBaseProfession = (payload) => ({
  type: 'SET_DATA_BASE_PROFESSION',
  payload,
})
export const setListPofessionOriginal = (payload) => ({
  type: 'SET_LIST_PROFESSION_ORIGIN',
  payload,
})
export const setVacancycData = (payload) => ({
  type: 'SET_VACANCYC_DATA',
  payload,
})
export const setFlagLoadingVacancy = (payload) => ({
  type: 'SET_FLAG_LOADING_VACANCYC_DATA',
  payload,
})
